export default __webpack_public_path__ + "static/ECHOvsTelemedicine-3d2a436c88353cbfd164be541761b29c.png";